<template>
  <div id="MeterSVG">
    <dv-full-screen-container>
      <top-header />
      <div class="main-content">
        <div class="block-left-right-content">
          <oneSVG />
          <div class="block-top-bottom-content">
            <tableFrom />
            <PCurve />
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import topHeader from '../mainPage/topHeader';
import oneSVG from './OneDistribution';
import tableFrom from './table';
import PCurve from './PCurve';
export default {
  name: 'MeterSVG',
  components: {
    topHeader,
    oneSVG,
    tableFrom,
    PCurve
  }
};
</script>

<style lang="less" scoped>
#MeterSVG {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url("./img/bg.png");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .block-left-right-content {
    flex: 1;
    display: flex;
    margin-top: 20px;
  }

  .block-top-bottom-content {
    width: 40%;
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }

  .block-top-content {
    height: 55%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
}
</style>
